import api from "../../api/cofocusAPI";

const StatisticsAPI = {
  /**
   *
   * @param {*} UID
   * @param {*} rangeStartMS
   * @param {*} rangeEndMS
   * @param {*} config
   * @returns
   */
  async getStatsInRange(UID, rangeStartMS, rangeEndMS, config) {
    if (!UID || !rangeStartMS || !rangeEndMS || !config) {
      return { success: false, error: "Required data not provided for request." };
    }
    return api.getResponseData({
      url: `api/statistics/${UID}?rangeStart=${rangeStartMS}&rangeEnd=${rangeEndMS}&config=${config}`,
      method: "get",
      withCredentials: true,
    });
  },
};

export default StatisticsAPI;
